import { Col, Form, Radio, Row, Space } from 'antd';
import Button from 'components/Button';
import { DownloadIcon } from 'assets/svg';
import { MainLayout } from 'components';
import useQueryParam from 'hooks/useQueryPrams';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { Content } from 'antd/es/layout/layout';
import type { RadioChangeEvent } from 'antd';
import { Icabinet } from 'interface/cabinet.interface';
import UploadFileCabinet from 'components/Modules/Cabinet/UploadFileCabinet';
import DeclareDirect from 'components/Modules/Cabinet/DeclareDirect';

export default function CreateCabinet() {
  const history = useHistory();
  const queryParam = useQueryParam();

  const [value, setValue] = useState(1);

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size = parseInt(queryParam.get('page_size') + '') || 4;
  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Thêm tủ, dòng hàng');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Thiết lập </a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/branch-cabinet">Tủ, dòng hàng </a>
          </p>
        ),
      },
      {
        title: <a href="">Thêm tủ</a>,
      },
    ]);
  }, []);

  const onChange = (e: RadioChangeEvent) => {
    console.log('radio checked', e.target.value);
    setValue(e.target.value);
  };

  const renderContent = (value: number) => {
    switch (value) {
      case 1:
        return <UploadFileCabinet />;
      case 2:
        return <DeclareDirect />;
      default:
    }
  };

  return (
    <MainLayout>
      <Content>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          className="mb-1"
        >
          <Col span={12}>
            <h6>Tủ, dòng hàng</h6>
          </Col>
          <Col span={12} className="flex justify-end">
            <Space>
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border="border-primary-50"
              >
                Tải mẫu tại đây
                <DownloadIcon />
              </Button>
            </Space>
          </Col>
        </Row>

        <Radio.Group className="flex gap-20" onChange={onChange} value={value}>
          <Radio value={1}>Upload danh sách</Radio>
          <Radio value={2}>Khai báo trực tiếp</Radio>
        </Radio.Group>

        <div className="mt-4">{renderContent(value)}</div>
      </Content>
    </MainLayout>
  );
}
